import React from 'react'

const iconProps = size => ({
  width: size,
  height: size,
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true,
})

export const DominantPatternIcon = ({ size = 16 }) => (
  <svg {...iconProps(size)}>
    <path
      d="M4.5 11.5L11.5 4.5M11.5 4.5H6.5M11.5 4.5V9.5"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const WatchForIcon = ({ size = 16 }) => (
  <svg {...iconProps(size)}>
    <path
      d="M8 2.75L13.25 12.25H2.75L8 2.75Z"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinejoin="round"
    />
    <path
      d="M8 6.25V9"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
    />
    <circle cx="8" cy="10.75" r="0.5" fill="currentColor" />
  </svg>
)

export const KeyContrastIcon = ({ size = 16 }) => (
  <svg {...iconProps(size)}>
    <path
      d="M3 5.5H13M13 5.5L10.5 3M13 5.5L10.5 8"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 10.5H3M3 10.5L5.5 8M3 10.5L5.5 13"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
